import React, { useState } from "react";
import axios from "axios";
import "../../styles/HomeStyling/RequestForm.css";

const RequestForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    fName: "",
    lName: "",
    email: "",
    company: "",
    message: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/request-account`,
        formData
      );
      if (response.data.success) {
        setSuccess("Request sent! We'll get back to you shortly.");
        setFormData({
          fName: "",
          lName: "",
          email: "",
          company: "",
          message: "",
        });
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        setError(response.data.message || "Something went wrong.");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "Network error. Please try again."
      );
    }
  };

  return (
    <div className="request-popup-overlay">
      <form className="request-form" onSubmit={handleSubmit}>
        <h2 className="request-title">Request Access</h2>
        {error && <p className="request-error">{error}</p>}
        {success && <p className="request-success">{success}</p>}

        <input
          type="text"
          name="fName"
          placeholder="First Name"
          value={formData.fName}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="lName"
          placeholder="Last Name"
          value={formData.lName}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="company"
          placeholder="Company"
          value={formData.company}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Brief message..."
          value={formData.message}
          onChange={handleChange}
          required
        />
        <div className="request-actions">
          <button type="submit" className="submit-btn">
            Send Request
          </button>
          <button type="button" className="cancel-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default RequestForm;
